import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function DecemalNum({
  className,
  type,
  strict,
  onChange,
  uppercase,
  ...props
}) {
  // Function to format numbers with commas
  const formatNumber = (value) => {
    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = value.split(".");

    // Format the integer part with commas
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ","
    );

    // Return the formatted number
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  };

  function onInput(e) {
    let value = e.target.value;

    // Strip non-numeric characters except for the decimal point
    value = value.replace(/[^\d.]/g, "");
    value = formatNumber(value);

    if (uppercase) {
      value = value.toUpperCase();
    }

    // Manually update the input value
    e.target.value = value;
    onChange(value);
  }

  return (
    <div>
      <input
        className={classNames("form-control", className)}
        onInput={onInput}
        {...props}
      />
      <br />
    </div>
  );
}
DecemalNum.defaultProps = defaultProps;
export default DecemalNum;
